import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {getUserCommuteLocation, getCommutTimes, getFormattedOptions} from './util';
//import { Popover } from 'react-bootstrap';
import EsriAutoComplete from './esriautocomplete';
import SelectBox from './select-box';
import * as searchActions from 'actions/search';
import * as profileActions from 'actions/profile';
import * as clientActions from 'actions/clients';
import commute_solo from '../img/svg/transicon_solo.svg';


class CommutePopup extends Component{

    constructor(props) {
        super(props);

        const { audience, profile, selectedClient } = this.props;

        var commuteLocation = "";
        var selectedClientId = null;

        if(audience && audience.type === 'client'){
            var uProfile = profile;
            if(uProfile !== undefined && uProfile !== null) {
                commuteLocation = getUserCommuteLocation(uProfile);
            }
        }
        else {
            var sClient = selectedClient;
            if(sClient !== undefined && sClient !== null) {
                commuteLocation = getUserCommuteLocation(sClient);
                if(sClient.Id) selectedClientId = sClient.Id;
            }
            else
            {
                var mCommute = this.props.searchParameters_Redux.commuteaddress;                              
                if(mCommute !== undefined && mCommute !== null && mCommute !== "")
                {
                    commuteLocation = mCommute;
                }
            }
        }

        this.state = {
            commuteLocation: commuteLocation,
            selectedClientId: selectedClientId,
            commuteTimeMins: (this.props.searchParameters_Redux && this.props.searchParameters_Redux.commutetimemins) ? this.props.searchParameters_Redux.commutetimemins : "45"
        };
        this.onFocus = this.onFocus.bind(this);
        
        //this.workingWithClient = this.workingWithClient.bind(this);

        this.handleAutoComplete = this.handleAutoComplete.bind(this);

        this.updateCommuteToProfile = this.updateCommuteToProfile.bind(this);

        this.handleCommuteTimeChange = this.handleCommuteTimeChange.bind(this);
        this.handleSelectClientCommute = this.handleSelectClientCommute.bind(this);
        
    }

    setCommute = (selectedClient) => {

        const { audience, profile } = this.props;

        var commuteLocation = "";
        var selectedClientId = null;

        if(audience && audience.type === 'client'){
            var uProfile = profile;
            if(uProfile !== undefined && uProfile !== null) {
                commuteLocation = getUserCommuteLocation(uProfile);
            }
        }
        else {
            var sClient = selectedClient;
            if(sClient !== undefined && sClient !== null) {
                commuteLocation = getUserCommuteLocation(sClient);
                if(sClient.Id) selectedClientId = sClient.Id;
            }
            else
            {
                var mCommute = this.props.searchParameters_Redux.commuteaddress;                              
                if(mCommute !== undefined && mCommute !== null && mCommute !== "")
                {
                    commuteLocation = mCommute;
                }
            }
        }

        if(this.refs.commutePopupRef){
            this.setState({
                commuteLocation: commuteLocation,
                selectedClientId: selectedClientId,
                commuteTimeMins: (this.props.searchParameters_Redux && this.props.searchParameters_Redux.commutetimemins) ? this.props.searchParameters_Redux.commutetimemins : "45"
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        if(JSON.stringify(this.props.selectedClient) !== JSON.stringify(nextProps.selectedClient)){
            this.setCommute(nextProps.selectedClient);
        }
    }

    handleAutoComplete(event){
        //if(this.refs.searchPageRef) {
            if(event !== undefined 
                && event !== null 
                && event.SearchedText !== undefined 
                && event.SearchedText !== null)
                {
                    let parameters = Object.assign({}, this.props.searchParameters_Redux);
                    parameters.commuteaddress = event.SearchedText;
                    parameters.page_number = 1;
                    parameters.skip = 0;
                    parameters.commutetimemins = this.state.commuteTimeMins ? this.state.commuteTimeMins : "45";
                    delete parameters["mapbound"];

                    this.props.searchActions.updateParameters(parameters);

                    if(this.props.handleAutoComplete) this.props.handleAutoComplete(event);
                }
        //}
    }

    onFocus(event) {
        //if (this.refs.searchPageRef) {
            if (document.getElementsByClassName('rbt-input-main').length === 2)
                document.getElementsByClassName('rbt-input-main')[1].select();
        //}
    }

    updateCommuteToProfile(){
        //console.log('updateCommuteToProfile');
        const {audience, selectedClient, profile} = this.props;
        var clientProfile = null;
        var commAddr = null;
        var commObj = null;
        if(audience && audience.type === "agent"){
            if(this.state.selectedClientId !== undefined && this.state.selectedClientId !== null && 
                this.state.selectedClientId !== "" && selectedClient !== undefined && selectedClient !== null){
                clientProfile = Object.assign({}, selectedClient);
                commAddr = this.props.searchParameters_Redux.commuteaddress;
                if(commAddr !== undefined && commAddr !== null && commAddr !== ""){
                    commObj = {CommuteDetail: [{}]};
                    if (clientProfile && clientProfile.Profile){
                        if (clientProfile && clientProfile.Profile && clientProfile.Profile.CommuteData &&
                            clientProfile.Profile.CommuteData.CommuteDetail && clientProfile.Profile.CommuteData.CommuteDetail.length > 0) {
                            commObj = clientProfile.Profile.CommuteData;
                        }
                        commObj.CommuteDetail[0].WorkAddress = commAddr;

                        clientProfile.Profile.CommuteData = commObj;

                        if(this.props.clientActions){
                            this.props.clientActions.updateClient(this.state.selectedClientId, clientProfile);                            
                        }
                    }
                }                
            }            
        }
        else if(audience && audience.type === "client"){
            if(profile !== undefined && profile !== null){
                clientProfile = Object.assign({}, profile);
                commAddr = this.props.searchParameters_Redux.commuteaddress;
                if(commAddr !== undefined && commAddr !== null && commAddr !== ""){
                    commObj = {CommuteDetail: [{}]};
                    if (clientProfile && clientProfile.Profile){
                        if (clientProfile.Profile.CommuteData && clientProfile.Profile.CommuteData.CommuteDetail && 
                            clientProfile.Profile.CommuteData.CommuteDetail.length > 0) {
                            commObj = clientProfile.Profile.CommuteData;
                        }
                        commObj.CommuteDetail[0].WorkAddress = commAddr;

                        clientProfile.Profile.CommuteData = commObj;

                        if(this.props.profileActions){
                            this.props.profileActions.updateProfile(clientProfile);
                        }
                    }
                }                
            }
        }
    }

    handleCommuteTimeChange(val){
        if(this.refs.commutePopupRef){
            this.setState({commuteTimeMins: val});
            if(this.props.handleCommuteTimeChange) this.props.handleCommuteTimeChange(val);
        }
    }

    handleSelectClientCommute(){
        if(this.state.commuteLocation !== undefined && this.state.commuteLocation !== null && this.state.commuteLocation !== "") {
            let parameters = Object.assign({}, this.props.searchParameters_Redux);
            parameters.commuteaddress = this.state.commuteLocation;
            parameters.commutetimemins = this.state.commuteTimeMins ? this.state.commuteTimeMins : "45";
            delete parameters["mapbound"];
            //this.setState({searchInitiator : "commute"});
            this.props.searchActions.updateParameters(parameters);
            if(this.props.handleSelectClientCommute) this.props.handleSelectClientCommute();
        }
    }

    render(){     
        
        const {audience, selectedClient, searchParameters_Redux, isFetchingClients, isFetchingProfile} = this.props;
        
        return(
            
                <div className="form-group"  style={{width: "250px", marginBottom: "0px"}} ref="commutePopupRef"> 
                    <div className="close_commute"><i className="fa fa-times" onClick={this.props.closePopup}></i></div>
                    {((audience && audience.type === 'agent' && selectedClient && 
                    selectedClient.FirstName && selectedClient.FirstName !== "") ||
                    (audience && audience.type === 'client')) ?
                    
                    <div style={{marginTop: "5px"}}>                        
                        <div className="commute-profile-box">
                            <div className="commute-profile-box-label">
                                {(audience && audience.type === 'agent' && selectedClient && 
                                selectedClient.FirstName && selectedClient.FirstName !== "") ?
                                <span>Commute from {selectedClient.FirstName}'s Profile</span> : null
                                }
                                {(audience && audience.type === 'client') ?
                                <span>Commute from Your Profile</span> : null
                                }
                            </div>
                            <div className="commute-profile-box-content">
                                <span className="commute-name-box">
                                    {this.state.commuteLocation && this.state.commuteLocation !== "" ? this.state.commuteLocation : "No commute"}
                                </span>
                                {this.state.commuteLocation && this.state.commuteLocation !== "" &&
                                <span className="commute-name-select" onClick={this.handleSelectClientCommute}>
                                    Select
                                </span>
                                }
                            </div>
                            {searchParameters_Redux.commuteaddress && 
                                searchParameters_Redux.commuteaddress !== this.state.commuteLocation &&
                            <div className="commute-update-profile-box">
                                <span>You searched with '{searchParameters_Redux.commuteaddress}' as commute. Would you like to update it in 
                                {(audience && audience.type === 'agent' && selectedClient && selectedClient.FirstName && selectedClient.FirstName !== "") ?
                                " " + selectedClient.FirstName + "'s Profile?" : 
                                (audience && audience.type === 'client') ? " Your Profile?" : ""}
                                {!isFetchingClients && !isFetchingProfile ?
                                <span className="commute-update-profile-btn" onClick={this.updateCommuteToProfile}>
                                    Update
                                </span> :
                                <span className="commute-update-profile-btn" style={{cursor: "default"}}>
                                    Updating..
                                </span>
                                }
                                </span>
                            </div>
                            }
                        </div>                        
                    </div> : null
                    }
                    <div>
                        
                        Search for homes within {(this.state.commuteTimeMins) ? this.state.commuteTimeMins : "45"} minutes commute by entering a city or street name:<br/>(Based on 8:45 AM arrival with traffic)<br/>
                        <div style={{marginTop: "5px"}}>
                            <span className="commute-time-box">
                                <SelectBox
                                    label="Travel Time"
                                    className="dropdown semicompact"
                                    value={(this.state.commuteTimeMins) ? this.state.commuteTimeMins : "45"}
                                    onChange={this.handleCommuteTimeChange}>
                                    {getFormattedOptions(getCommutTimes())}
                                </SelectBox>
                            </span>
                            <span className="commute-mode-box">
                                <img src={ commute_solo } style={{ filter: 'invert(100%)'}} alt="Commute Selection" />
                                {/* <i className="fa fa-car"></i> */}
                            </span>
                        </div>      
                        <div style={{border: "1px solid #ddd", width: "250px", marginTop:"5px"}} >
                            <EsriAutoComplete
                                className="input-group agentcommute"
                                placeholder="Enter a city"
                                defaultSelected={this.state.locationText}
                                handleAutoComplete={this.handleAutoComplete}
                                onFocus={this.onFocus} />
                        </div>   
                    </div>                 
                </div>

        );
    }
}

const mapStateToProps = (state, props) => ({
    audience: state.session.audience,
    profile: state.profile.mine,
    isFetchingProfile: state.profile.isFetching,
    selectedClient: state.entities.clients[state.clients.selectedClient],
    isFetchingClients: state.clients.isFetching,
    searchParameters_Redux: state.search.parameters
});

const mapDispatchToProps = dispatch => ({
    searchActions: bindActionCreators(searchActions, dispatch),
    profileActions: bindActionCreators(profileActions, dispatch),
    clientActions: bindActionCreators(clientActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(CommutePopup);